<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.sidemenu.data_privacy"
            small
            multiLineTitle
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-6"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0">

            <div class="">
                <div class="text-base h-full overflow-y-auto py-5" v-html="privacyContent"></div>
            </div>

        </PageContent>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: 'Terms',
    components: {
        TopBarBg,
        PageContent,
    },
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            privacyContent: '',
            privacyVersion: 0,

            modalController: null,
        };
    },
    created: function() {
        this.setupPrivacy();

        this.modalController.setAlertModal(this.alertModal);
    },
    methods: {
        setupPrivacy: async function() {
            await this.apiGetPrivacyVersion();
            await this.apiGetPrivacyContent();
        },

        apiGetPrivacyVersion: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe((data) => {
                    this.privacyVersion = data.privacy.current_version;
                    resolve(data);
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
        apiGetPrivacyContent: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAContent('privacy', this.privacyVersion, this.localeCode + '.txt')
                    .subscribe((data) => {
                        this.privacyContent = data;
                        resolve(data);
                    }, (err) => {
                        this.errorApi(err);
                        reject(err);
                    });
            });
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
